import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { EventsService } from '../../../services/events/events.service';
import { Utils } from 'app/components/utils/Utils';
import { ParameterCart } from 'app/models/cart-model';
import { ItemCart } from '../../../models/cart-model';
import * as moment from 'moment-timezone';
import { LangModel } from 'app/models/lang-model';
import { LoaderService } from 'app/services/loader/Loader.service';
import { Constants } from 'app/components/utils/Constants';
import { ResumenPayment } from 'app/models/resumen-payment-model';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Log } from 'app/core/logging/log';
import { ItemInfoCart } from 'app/models/info-cart-model';


@Component({
  selector: 'app-locker-visor',
  templateUrl: './locker-visor.page.html',
  styleUrls: ['./locker-visor.page.scss'],
})
export class LockerVisorPage implements OnInit {

  paymentUuid: string = '';
  active: boolean = false;
  toPay: boolean = false;
  tracks: any;
  canceled: boolean = false;
  cancelable: boolean = false;
  subscription: boolean = false;
  closed: boolean = false;
  refresh: boolean = false;
  loading: number = 0;
  resumePayment: ResumenPayment = {
    startDate: null, endDate: null, items: [], total: 0, tax: 0,
    kioskAddress: '',
    locationCode: '',
    userData: {
      email: ''
    },
    renovation: null
  };
  t: boolean = true;
  waitingTime: string = null;

  constructor(
    private restService: RestService,
    public appService: AppService,
    private gtmService: GoogleTagManagerService,
    private router: Router,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private loadingService: LoaderService
  ) { 
    this.paymentUuid = this.route.snapshot.queryParamMap.get('code') || '';
  }

  ngOnInit() {
    this.getResumenOnline();

    const gtmTag = {
      event: 'visor_resume',          // Nombre del evento en GTM
      conversion_value: 10,          // Precio de la venta
      conversion_currency: 'EUR',    // Opcional, útil para Google Ads / GA4
      payment_uuid: this.paymentUuid
    };

    Log.debug("google tagmanager");
    this.gtmService.pushTag(gtmTag);
  }

  ngAfterViewInit(){
    this.eventsService.publish('refreshStep', { title: "Resumen", nameBt: null });
  }

  ngOnDestroy() {
    this.t = false;
  }

  getResumenOnline(){
    this.loadingService.setLoading(true);
    this.restService.getResumenOnline(this.paymentUuid).subscribe((result:any) => { 
      if(result !=null){
        this.setLang(result);
        this.resumePayment = result;
      }
      
      this.appService.kiosk = this.resumePayment.locationCode;
      this.canceled = result.canceled;
      this.cancelable = result.cancelable;
      this.active = result.active;
      this.closed = result.closed;
      this.refresh = result.refresh;
      this.subscription = result.subscription;

      //if(this.allIsClosed){
       // alert('Todas las reservas cerradas');
       // this.router.navigate(['reserve/locker-type']);
      //}

      this.refreshMode();

    });
  }

  cancelCheckoutCard(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    if(this.subscription){
      this.restService.cancelSubscription(this.paymentUuid).subscribe((result:any) => { 
       setTimeout(()=> location.reload());
      }, 
      err => {
        setTimeout(()=> location.reload());
      });
    }else{
      this.restService.cancelCheckoutCard(this.paymentUuid).subscribe((result:any) => { 
        setTimeout(()=> location.reload());
      },
      error => {
        Log.error('Error cancel');
        setTimeout(()=> location.reload());
      });
    }
    
  }


  resendEmail(){
    this.restService.resendEmailUser(this.paymentUuid).subscribe((result:any) => { 
      if(result == null){
        this.waitingTime = null;
        this.appService.showSuccessToast(Constants.MSG_SUCCESS, 3000);        
      }else{
        this.waitingTime = this.appService.getTraduccion('visor.resume.resend.waintingTime').replace("%s", result);

        let remainingSeconds = result;
        const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
          remainingSeconds--;
          this.waitingTime = this.appService.getTraduccion('visor.resume.resend.waintingTime').replace("%s", String(remainingSeconds));

          if (remainingSeconds <= 0) {
            clearInterval(intervalId);
            this.waitingTime = null;
          }
        }, 1000);

      }
    });
  }
  


  refreshMode(){
    if(this.refresh){
        this.loading = 1;
        this.loadingService.setLoading(true);
        setTimeout(()=>{
          if(this.t){
            this.getResumenOnline();
          }
        }, 3000);
      }else{
        this.loading = 2;
        this.loadingService.setLoading(false);
      }
  }


  goToPay(itemInfoCart: ItemInfoCart){
    moment.locale("es");
    let startDate = this.resumePayment.renovation.startDate;
    let endDate = this.resumePayment.renovation.endDate;
    let now = moment(startDate);
    let future = moment(endDate);

    let itemCart:ItemCart = {
      reservationUuid: itemInfoCart.reservationUuid,
      categoryId: itemInfoCart.categoryId
    }
    let parameters:ParameterCart = {
      type: itemInfoCart.categoryId, //TODO deberia ser categoría padre
      items: [itemCart],
      startDate: this.formatDateTime(now),
      endDate: this.formatDateTime(future),
      userData: this.resumePayment.userData,
    }
    
    this.router.navigate(['/reserve', this.appService.kiosk, 'checkout'], { queryParams: Utils.generateParams(parameters) });
  }

  formatDateTime(datetime: moment.Moment) {
    if (datetime == undefined) {
        return "";
    }
    return datetime.format('DD-MM-YYYY HH:mm')
  }

  setLang(resumenPayment: any){
    if(resumenPayment.userData.langCode != null){
      let lang:LangModel = {
        landId: 0,
        name: resumenPayment.userData.langCode
      }
      AppService.setLang(lang);
    }
  }

}
